import axios from "axios";
import { baseURL } from "./constants";

const instance = axios.create({
  timeout: 20000,
  baseURL: baseURL,
});

const AUTH_LOGOUT_DETAILS = [
  "the user's password has been changed.",
  "given token not valid for any token type",
  "user not found",
  "user is inactive",
  "authentication credentials were not provided.",
];

const shouldForceLogout = (error) => {
  const status = error.response?.status;
  if (status !== 401) return false;

  const url = String(error.config?.url || "");
  if (
    url.includes("/users/login/") ||
    url.includes("password-reset") ||
    url.includes("/reset-password")
  ) {
    return false;
  }

  const detail = error.response?.data?.detail;
  const message = String(detail || "").toLowerCase();
  return AUTH_LOGOUT_DETAILS.some((item) => message.includes(item));
};

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (shouldForceLogout(error)) {
      localStorage.removeItem("userInfoExpressHalalAdmin");
      if (window.location.pathname !== "/") {
        window.location.href = "/";
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
